import Vue from 'vue';

import * as types from './mutation-types';

const mutations = {
  [types.SET_CARD](state, card) {
    Vue.set(state.cards, card.id, card);
  },

  [types.SET_CARDS](state, cards) {
    cards.forEach((card) => {
      if (card) {
        Vue.set(state.cards, card.id, card);
      }
    });
  },

  [types.SET_PAGINATION](state, pagination) {
    Vue.set(state, 'pagination', pagination);
  },

  [types.SET_CORECONCEPT](state, coreConcept) {
    Vue.set(state, 'coreConcept', coreConcept);
  },

};

export default mutations;
